import { render } from "./ThemeChart.vue?vue&type=template&id=64b2d99a&scoped=true"
import script from "./ThemeChart.vue?vue&type=script&lang=js"
export * from "./ThemeChart.vue?vue&type=script&lang=js"

import "./ThemeChart.vue?vue&type=style&index=0&id=64b2d99a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b2d99a"]])

export default __exports__